import ClientAgreement from './Client_Agreement.pdf';
import CookiesPolicy from './Cookies_Policy.pdf';
import PrivacyPolicy from './Privacy_Policy.pdf';
import RiskDisclosure from './Risk_Disclosure.pdf';

export default {
  ClientAgreement,
  CookiesPolicy,
  PrivacyPolicy,
  RiskDisclosure,
};
